import { render, staticRenderFns } from "./PluginPreview.vue?vue&type=template&id=fbf61d24&scoped=true&"
import script from "./PluginPreview.vue?vue&type=script&lang=js&"
export * from "./PluginPreview.vue?vue&type=script&lang=js&"
import style0 from "./PluginPreview.vue?vue&type=style&index=0&id=fbf61d24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf61d24",
  null
  
)

export default component.exports